angular.module('impactx.beco').controller('BecoOrderListCtrl', BecoOrderListCtrl);

function BecoOrderListCtrl() {
    this.meta = {
        rowTemplate: 'modules/beco/templates/beco.row.html',
        isSelectAble: false,
        endpoint: '/beco/order',
        ctrl: this,
        id: "becoorderlist",
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    };
}